const HERO_TITLES = {
  critical: [
    "Há pontos críticos que precisam de atenção agora",
    "Alguns processos exigem intervenção imediata",
    "Operação em alerta. Veja o que precisa de ação",
    "Indicadores críticos detectados. Por onde começar?",
  ],
  warning: [
    "Alguns indicadores merecem revisão hoje",
    "Fique de olho, há pontos que merecem atenção",
    "Operação em atenção, revise os destaques do dia",
    "Há pontos a monitorar de perto hoje",
  ],
  healthy: [
    "Operação estável, acompanhe os destaques do dia",
    "Tudo em ordem por aqui, veja o que está em destaque",
    "Indicadores saudáveis, mantenha o ritmo",
    "Operação saudável, confira o resumo do dia",
  ],
  neutral: [
    "Veja o que precisa de ação agora",
    "O que está acontecendo na operação hoje",
    "Acompanhe sua operação em tempo real",
    "Por onde você quer começar hoje?",
  ],
};

export default function getHeroTitle(status) {
  const options = HERO_TITLES[status] || HERO_TITLES.neutral;
  return options[Math.floor(Math.random() * options.length)];
}
